import { render, staticRenderFns } from "./order-email.vue?vue&type=template&id=4f207898"
import script from "./order-email.vue?vue&type=script&lang=js"
export * from "./order-email.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports